import { put, call } from 'redux-saga/effects';
import { notificationCreateAPI, notificationSearchAPI, notificationUpdateAPI } from 'src/api/NotificationApi';
import { SEARCH_RECORD_PAGE_LIMIT } from 'src/constants/CommonConstants';
import { headerShowAction } from 'src/containers/header-container/actions/HeaderActions';
import { takeFirstSagaUtil } from 'src/utils/ReduxSagaUtils';
import { buildSearchWithNoCase } from 'src/utils/CommonUtils';
import { NOTIFICATION_ACTIONS } from '../actions/NotificationActions';
import { toast } from 'react-toastify';

function* search({
    where, currentPage = 0, autopopulate = true, fullTextSearch = true,
} = {}) {
    try {
        const {
            data: {
                data,
            },
        } = yield call(notificationSearchAPI, {
            where: buildSearchWithNoCase({
                where,
                fullTextSearch,
            }),
            pageLength: SEARCH_RECORD_PAGE_LIMIT,
            currentPage,
            autopopulate,
        });

        yield put({
            type: NOTIFICATION_ACTIONS.NOTIFICATION_SEARCH_SUCCESS,
            data,
        });

        return data;
    }
    catch (error) {
        console.error('LOG: function*search -> error', error);
        yield put({
            type: NOTIFICATION_ACTIONS.NOTIFICATION_SEARCH_ERROR,
        });
        return null;
    }
}

function* edit({
    _id,
}) {
    try {
        const {
            data: {
                data: {
                    data,
                },
            },
        } = yield call(notificationSearchAPI, {
            where: {
                _id,
            },
            autopopulate: false,
        });

        if (!data || !data[0]) {
            
            yield put(headerShowAction({
                data: 'Unable to Edit, something when wrong',
            }));
        }

        
        yield put({
            type: NOTIFICATION_ACTIONS.NOTIFICATION_UPSERT_SUCCESS,
            data: data[0],
        });
    }
    catch (error) {
        console.error('LOG: error', error);

        yield put(headerShowAction({
            data: error.response.data.data,
        }));

        yield put(headerShowAction({
            data: error.response.data.data,
        }));
    }
}

function* insert(payload) {
    try {
        const {
            data: {
                data,
            },
        } = yield call(notificationCreateAPI, payload);

        yield put(headerShowAction({
            data: 'Created',
        })); 
        toast("Notification Created")
        
        yield put({
            type: NOTIFICATION_ACTIONS.NOTIFICATION_UPSERT_SUCCESS,
            data: {
                ...payload,
                _id: data._id,
            },
        });
        yield put({
            type: NOTIFICATION_ACTIONS.NOTIFICATION_SEARCH
        });
    }
    catch (error) {
        console.error('LOG: upsert error', error);
        yield put(headerShowAction({
            data: error.response.data.data,
        }));

        yield put({
            type: NOTIFICATION_ACTIONS.NOTIFICATION_UPSERT_ERROR,
        });
    }
}

function* update(notificationId, payload) {
    try {
        yield call(notificationUpdateAPI, {
            notificationId,
            data: payload,
        });

        yield put(headerShowAction({
            data: 'Updated',
        }));
        if(payload.deleted===true){
            toast("Notification deleted")
        }
        else{
            toast("Notification updated")
        } 
        
        yield put({
            type: NOTIFICATION_ACTIONS.NOTIFICATION_SEARCH
        });
    }
    catch (error) {
        console.error('LOG: upsert error', error);
        yield put(headerShowAction({
            data: error.response.data.data,
        }));

        yield put({
            type: NOTIFICATION_ACTIONS.NOTIFICATION_UPSERT_ERROR,
        });
    }
}

function* upsert({
    _id,
    ...payload
}) {
    if (_id) {
        yield update(_id, payload);
    }
    else {
        yield insert(payload);
    }
}

export default [
    takeFirstSagaUtil(NOTIFICATION_ACTIONS.NOTIFICATION_SEARCH, search),
    takeFirstSagaUtil(NOTIFICATION_ACTIONS.NOTIFICATION_UPSERT, upsert),
    takeFirstSagaUtil(NOTIFICATION_ACTIONS.NOTIFICATION_EDIT, edit),
];
